

document.addEventListener("DOMContentLoaded", () => {
  const jeiCustomVideo = document.querySelector(".jei-custom-video video");
  const jeiCustomVideoImage = document.querySelector(".jei-custom-video-image");
  const jeiCustomVideoButtons = document.querySelectorAll(".jei-custom-video-ButtonDiv button");
  const jeiCustomVideoButtonDivImage = document.querySelector(".jei-custom-video-ButtonDiv-image");

  // Safety check
  if (!jeiCustomVideo || !jeiCustomVideoImage || !jeiCustomVideoButtons.length || !jeiCustomVideoButtonDivImage) {
    return;
  }

  let isPlaying = false;

  jeiCustomVideoButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      if (!isPlaying) {
        // Play
        jeiCustomVideoImage.style.display = "none";
        jeiCustomVideo.play();
        btn.textContent = "Pause";
        jeiCustomVideoButtonDivImage.src =
          "https://cdn.shopify.com/s/files/1/0582/8558/8579/files/pause.svg?v=1764142727";
        isPlaying = true;
      } else {
        // Pause
        jeiCustomVideo.pause();
        jeiCustomVideoImage.style.display = "block";
        btn.textContent = "See it in Action";
        jeiCustomVideoButtonDivImage.src =
          "https://cdn.shopify.com/s/files/1/0582/8558/8579/files/play.svg?v=1764142602";
        isPlaying = false;
      }
    });
  });







});









